import { observer } from 'mobx-react-lite';
import EndpointPage from './EndpointPage';
import { EndpointPageProps, EndpointPageValueProps } from './types';

export type { EndpointPageProps, EndpointPageValueProps };
export default observer(EndpointPage); // MANUAL OVERRIDE
